import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { useStyles } from "./detailStyles";

const DetailRow = ({ label, value, positiveValue = true }) => {
  const classes = useStyles();
  return (
    <Grid
      container
      justifyContent="space-between"
      spacing={2}
      className={classes.gridSpacing}
    >
      <Grid item>
        <Typography className={classes.description}>{label}</Typography>
      </Grid>
      <Grid item>
        <Typography
          className={
            positiveValue ? classes.description : classes.negativeValue
          }
        >
          {value}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default DetailRow;
